<template>
    <div class="container">
        <el-header>
            <h3 class="system_title">意霆数字化医疗设备管理平台</h3>
            <ul class="header_right">
                <li @click="toggleNotificationPanel" class="notification-wrapper">
                    <div class="icon_box">
                        <el-badge :value="notificationCount" :max="99" class="badge_style" :hidden="notificationCount === 0">
                            <i class="el-icon-message-solid"></i>
                        </el-badge>
                        通知
                    </div>
                    <notification-panel
                        :visible="showNotificationPanel"
                        :alarm-list="alarmList"
                        :alarm-count="numberOfAlarms"
                        :device-status-list="deviceStatusList"
                        :device-status-count="numberOfDeviceStatuses"
                        @item-click="handleAlarmClick"
                        @device-status-click="handleDeviceStatusClick"
                        @process="handleAlarmProcess"
                        @mark-all-read="handleMarkAllRead"
                        @close="showNotificationPanel = false"
                        @click.native.stop
                    />
                </li>
                <li>
                    <span @mouseenter="delayedOpen" @mouseleave="delayedClose" class="icon_box">
                        <i class="el-icon-user-solid"></i>
                        {{ userName }}
                    </span>
                    <!-- 弹窗元素 -->
                    <div v-if="isPopupVisible" @mouseenter="clearCloseTimeout" @mouseleave="delayedClose" class="popup">
                        <div @click="jumpUserDetails">个人资料</div>
                        <div @click="logout">退出登录</div>
                    </div>
                </li>
            </ul>
        </el-header>
        <el-container>
            <el-aside width="200px">
                <el-menu :default-active="onRoutes" router :unique-opened="true" background-color="#fff"
                    @select="handleMenuSelect">
                    <!-- <el-menu :default-active="'/platOverview'" router :unique-opened="true" background-color="#fff"> -->
                    <template v-for="(item, index) in filteredMenuList">
                        <el-submenu v-if="item.children && item.children.length > 0" :index="item.path" :key="'submenu-' + index">
                            <template slot="title">
                                <i :class="item.iconclass"></i>
                                <span>{{ item.name }}</span>
                            </template>
                            <el-menu-item v-for="(subItem, subIndex) in item.children" :key="subIndex"
                                :index="subItem.path">
                                {{ subItem.name }}
                            </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-else :index="item.path" :key="'item-' + index">
                            <i :class="item.iconclass"></i>
                            <span>{{ item.name }}</span>
                        </el-menu-item>
                    </template>
                </el-menu>
            </el-aside>
            <el-main>
                <!-- 面包屑功能 -->
                <!-- <div class="main_top">
                    <BreadCrumb />
                </div> -->
                <div class="main_btm">
                    <router-view></router-view>
                </div>
            </el-main>
        </el-container>
    </div>
</template>


<script>
// import BreadCrumb from '@/components/breadCrumb.vue'
import NotificationPanel from '@/components/notification/NotificationPanel.vue';
import notificationCenterMixin from '@/components/notification/notificationCenterMixin.js';
import { logoutFn } from '@/api/system.js';
import { clearAuth, getUIProfile, getUsername, isManager } from '@/utils/auth.js';
import { applyCustomMenus } from '@/config/customProfiles.js';
import { BASE_MENU_LIST, filterMenus } from '@/config/permissions.js';

export default {
    mixins: [notificationCenterMixin],
    components: {
        // BreadCrumb
        NotificationPanel
    },
    data() {
        return {
            userName: getUsername(),
            isPopupVisible: false,
            closeTimeout: null,
        }
    },
    methods: {
        handleMenuSelect(key) {
            // 监控大屏 / GIS 大屏 分别带 mode query 在新标签打开
            if (key === '/largeScreen/monitor' || key === '/largeScreen/gis') {
                const mode = key.endsWith('monitor') ? 'monitor' : 'gis'
                const routeData = this.$router.resolve({ path: '/largeScreen', query: { mode } })
                window.open(routeData.href, '_blank')
                return
            }
            if (key === '/glsLargeScreen') {
                // 兼容老入口：默认开 GIS 大屏
                const routeData = this.$router.resolve({ path: '/largeScreen', query: { mode: 'gis' } })
                window.open(routeData.href, '_blank')
            }
        },
        // 当前用户悬出框相关方法
        delayedOpen() {
            this.clearCloseTimeout();
            this.isPopupVisible = true;
        },
        delayedClose() {
            // 设置一个延时，给用户时间移动到弹窗上
            this.closeTimeout = setTimeout(() => {
                this.isPopupVisible = false;
            }, 300); // 延时300毫秒关闭
        },
        clearCloseTimeout() {
            // 清除已设定的延时关闭，防止弹窗意外关闭
            if (this.closeTimeout) {
                clearTimeout(this.closeTimeout);
                this.closeTimeout = null;
            }
        },
        jumpUserDetails() {
            this.$router.push({ path: '/systemManage/userDetails' });
        },
        logout() {
            this.$confirm('确认退出登录吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                // 1) 先请后端撤销当前 token（加入黑名单），best-effort：
                //    即便接口失败/超时也要继续清本地，避免卡在已登出页面。
                try {
                    await logoutFn();
                } catch (e) {
                    // 网络异常或 token 已失效，对用户而言都算"已登出"，忽略即可
                }
                // 2) 清掉登录时写入的全部身份信息（统一走 clearAuth；token 在
                //    localStorage，不是 sessionStorage）。
                clearAuth();
                // 3) 跳转到登录页
                this.$router.push('/login');
            }).catch(() => {});
        },
    },
    // watch removed
    computed: {
        onRoutes() {
            return this.$route.path
        },
        filteredMenuList() {
            const list = applyCustomMenus(BASE_MENU_LIST, getUIProfile());
            return filterMenus(
                list,
                this.$store.state.permission.pageKeys,
                isManager(),
            );
        }
    }

}
</script>


<style lang='less' scoped>
@import '~@/styles/tokens.less';

// 菜单品牌色（故意区别于 @color-primary，是主视觉的品牌蓝紫渐变）
@menu-accent: #2D5BFF;
@menu-accent-end: #3AEFFF;

.container {
    width: 100%;
    height: 100%;
    background-color: @color-bg-page;
}

.el-header {
    height: 64px;
    background: @color-bg-card;
    color: @text-main;
    text-align: center;
    line-height: 64px;
    padding: 0 40px !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    position: relative;
    z-index: 1000;
    border-bottom: 1px solid @color-border;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;

    .system_title {
        font-size: 22px;
        font-weight: 700;
        color: @text-main;
        letter-spacing: 1px;
        position: relative;
        padding-left: 0;
        display: flex;
        align-items: center;

        &::before {
            display: none;
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 92px;
            height: 34px;
            background: url('@/assets/yiting_logo_new.png') no-repeat center;
            background-size: contain;
        }
    }

    .header_right {
        display: flex;
        align-items: center;

        li {
            height: 32px;
            line-height: 32px;
            padding: 0 @spacing-lg;
            border-left: 1px solid @color-border;
            cursor: pointer;
            transition: all 0.3s ease;
            color: @color-text-regular;

            &:hover {
                background: @color-bg-page;
                border-radius: @radius-sm;
                color: @color-primary;
            }

            .icon_box {
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: @font-size-md;
                font-weight: @font-weight-medium;

                i {
                    margin-right: @spacing-sm;
                    font-size: 18px;
                    transition: transform 0.3s ease;
                    color: @color-text-secondary;
                }

                &:hover i {
                    transform: scale(1.1);
                    color: @color-primary;
                }

                .el-icon-user-solid,
                .el-icon-message-solid {
                    font-size: 18px;
                }
            }

            &:nth-child(1) {
                border: 0;
            }

            &:nth-child(2) {
                position: relative;

                .popup {
                    position: absolute;
                    left: 14px;
                    margin-top: @spacing-sm;
                    width: 120px;
                    background-color: @color-bg-card;
                    border-radius: @radius-md;
                    padding: @spacing-sm 0;
                    box-shadow: @box-shadow-hover;
                    border: 1px solid @color-border;
                    z-index: 9999;
                    transition: all 0.3s ease;
                    opacity: 0;
                    transform: translateY(-10px);
                    animation: popupFadeIn 0.3s ease forwards;

                    @keyframes popupFadeIn {
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    div {
                        height: 40px;
                        color: @text-main;
                        line-height: 40px;
                        text-align: center;
                        cursor: pointer;
                        padding: 0 @spacing-md;
                        transition: all 0.3s ease;

                        &:hover {
                            background-color: @color-bg-page;
                            color: @menu-accent;
                        }

                        &:first-child {
                            border-bottom: 1px solid @color-border;
                        }
                    }
                }
            }

            .badge_style {
                /deep/.el-badge__content {
                    border: 0;
                    background: @color-danger;
                    box-shadow: none;
                    height: 16px;
                    line-height: 16px;
                    padding: 0 @spacing-xs;
                }

                /deep/.el-badge__content.is-fixed {
                    position: absolute;
                    top: -6px;
                    right: 14px;
                    transform: translateY(-50%) translateX(100%);
                }
            }
        }
    }
}

.el-container {
    height: calc(100% - 64px);
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    display: flex !important;
    flex-direction: row !important;
}

.el-aside {
    background-color: @color-bg-card;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    border-right: 1px solid @color-border;
    flex-shrink: 0 !important;
    width: 200px !important;
    // 隐藏侧边栏滚动条（保留可滚行为，小屏下仍可滑动）
    scrollbar-width: none; // Firefox
    -ms-overflow-style: none; // IE/Edge

    &::-webkit-scrollbar {
        width: 0;
        height: 0;
        display: none;
    }
}

.el-menu {
    border: 0;
    padding: @spacing-sm 0;

    .el-menu-item {
        font-size: @font-size-md;
        margin: @spacing-xs 0;
        border-radius: 0 24px 24px 0;
        margin-right: @spacing-md;
        height: 48px;
        line-height: 48px;
        padding-left: @spacing-md !important;

        i {
            font-size: 18px;
            color: @color-text-regular;
            margin-right: @spacing-sm;
            transition: all 0.3s ease;
            display: inline-block;
            width: 18px;
            text-align: center;
            vertical-align: middle;
        }

        span {
            vertical-align: middle;
        }

        &:hover {
            background-color: @color-bg-page;
            color: @menu-accent;

            i {
                color: @menu-accent;
                transform: scale(1.1);
            }
        }

        &.is-active {
            background: linear-gradient(90deg, @menu-accent 0%, @menu-accent-end 100%) !important;
            color: #fff;
            box-shadow: 0 4px 12px fade(@menu-accent, 20%);
            font-weight: @font-weight-medium;

            i {
                color: #fff;
            }
        }
    }

    .el-menu.el-menu--inline {
        .el-menu-item {
            padding-left: 48px !important;
            height: 40px;
            line-height: 40px;
            font-size: @font-size-sm;
        }
    }

    /deep/.el-submenu__title {
        height: 48px;
        line-height: 48px;
        padding: 0 @spacing-md !important;

        i {
            font-size: 18px;
            color: @color-text-regular;
            margin-right: @spacing-sm;
            transition: all 0.3s ease;
            display: inline-block;
            width: 18px;
            text-align: center;
            vertical-align: middle;
        }

        span {
            vertical-align: middle;
        }

        &:hover {
            background-color: @color-bg-page;
            color: @menu-accent;

            i {
                color: @menu-accent;
                transform: scale(1.1);
            }
        }
    }

    /deep/.el-submenu__icon-arrow {
        font-size: @font-size-md;
        transition: all 0.3s ease;
        margin-top: -2px;
    }

    /deep/.el-submenu.is-active > .el-submenu__title {
        color: @menu-accent;
        font-weight: @font-weight-medium;
    }

    /deep/.el-submenu.is-opened > .el-submenu__title {
        .el-submenu__icon-arrow {
            transform: rotateZ(180deg);
        }
    }
}

.el-main {
    height: 100%;
    background-color: @color-bg-page;
    padding: 0;
    box-sizing: border-box;
    overflow-x: visible !important;
    overflow-y: auto;

    .main_btm {
        height: 100%;
        background-color: @color-bg-card;
        padding: 0;
        box-sizing: border-box;
        overflow-x: visible !important;
        overflow-y: auto;
        width: 100% !important;
        max-width: 100% !important;
    }
}

.notification-wrapper {
    position: relative;
}
</style>
